import axios from "axios"
import { ElMessage } from "element-plus";
// import { useRouter } from "vue-router";

var instance = axios.create({
  baseURL: '/admin', 
  // timeout: 10000,
  headers: {
      'Content-Type': 'application/json;charset=UTF-8;',
      'accessToken':sessionStorage.getItem('token')
  }
})

const AUTH_EXPIRED_CODES = new Set([70001, 70002, -1])
let isHandlingAuthExpired = false

const isAuthExpiredResponse = (response) => {
  const { code } = response?.data || {}
  const url = response?.config?.url || ''
  return url !== '/admin/login' && AUTH_EXPIRED_CODES.has(Number(code))
}


//请求拦截器 
instance.interceptors.request.use((config) => {
  // console.log(config)
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token
    config.headers.accessToken = token
  } else {
    delete config.headers.Authorization
    delete config.headers.accessToken
  }
  if (config.method === 'POST') {
      config.data = JSON.stringify(config.data);
  }
  return config;
}, (error) => {
  ElMessage({
    message: error.message || '请求发送失败，请稍后重试',
    type: 'error',
    center: true,
  })
  return Promise.reject(error)
});

// 响应拦截器
instance.interceptors.response.use(res=>{
  // console.log(res)
  // const router = useRouter();
  if (isAuthExpiredResponse(res)) {
    const error = new Error('auth expired')
    error.isAuthExpired = true
    error.response = res

    if (isHandlingAuthExpired) {
      return Promise.reject(error)
    }

    isHandlingAuthExpired = true
    sessionStorage.removeItem("token")
    ElMessage({
      message: "登录失效，请重新登录",
      type: "error",
      center: true,
    });
    setTimeout(()=>{
      // router.push("/Login")
      // window.location.href = "/Login"
      location. reload() 
      sessionStorage.removeItem("token")
    },2000)
    return Promise.reject(error)
  }
  return res
},err=>{
  if (err?.isAuthExpired) {
    return Promise.reject(err)
  }
  ElMessage({
    message: err.response?.data?.msg || err.message || '请求失败，请稍后重试',
    type: 'error',
    center: true,
  })
  return Promise.reject(err)  //返回错误
})

export default instance;


